import { Sidebar } from "@/components/ui/sidebar";
import { useLayout } from "../providers/LayoutProvider";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { collapsible, variant } = useLayout();
  return (
    <Sidebar
      {...props}
      collapsible={collapsible}
      variant={variant}
      className="border-sidebar-border transition-all duration-300 ease-in-out"
    />
  );
}